import { useParams } from 'react-router-dom'
import { useCronLog } from '@/modules/cron-logs/hooks/useCronLog'
import { CronLogDetail } from '@/modules/cron-logs/components/CronLogDetail'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function CronLogDetailPage() {
  const { id } = useParams<{ id: string }>()
  const logId = Number(id)
  const { data: log, isLoading, error } = useCronLog(logId)

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (error) {
    return <ErrorState message={error} />
  }

  if (!log) return null

  return <CronLogDetail log={log} />
}
